import Form from "./form";
import { observable, action } from "mobx";
import { lengthAtLeast, validUrl } from "core/validation";

export default class BitBucketServerForm extends Form {
  @observable token: string;
  @observable url: string;
  @observable showing: boolean;

  validators = {
    token: { validator: lengthAtLeast(10), message: "Invalid token" },
    url: { validator: validUrl, message: "Invalid URL" },
  };

  @action
  setDefaults() {
    this.token = "";
    this.token = "";
    this.showing = false;
  }
}
